export const nodeHasTag = (node, tag) => (node.name.split('.').includes(tag));
